import { useState, useCallback, useRef } from 'react';

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const useSplitPanel = ({ initialRatio = 0.65, minRatio = 0.4, maxRatio = 0.85 } = {}) => {
  const [ratio, setRatio] = useState(initialRatio);
  const containerRef = useRef(null);

  const startResizing = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      const container = containerRef.current;
      if (!container) return;
      const rect = container.getBoundingClientRect();
      const pointerId = event.pointerId ?? null;

      const updateRatio = (clientX) => {
        const delta = clientX - rect.left;
        const nextRatio = delta / rect.width;
        setRatio(clamp(nextRatio, minRatio, maxRatio));
      };

      const handleMove = (moveEvent) => {
        if (pointerId !== null && moveEvent.pointerId !== pointerId) return;
        moveEvent.preventDefault();
        updateRatio(moveEvent.clientX ?? 0);
      };

      const handleUp = (upEvent) => {
        if (pointerId !== null && upEvent.pointerId !== pointerId) return;
        window.removeEventListener('pointermove', handleMove);
        window.removeEventListener('pointerup', handleUp);
      };

      window.addEventListener('pointermove', handleMove, { passive: false });
      window.addEventListener('pointerup', handleUp);
    },
    [minRatio, maxRatio]
  );

  const attachContainer = useCallback((node) => {
    containerRef.current = node;
  }, []);

  return { ratio, startResizing, attachContainer };
};

export default useSplitPanel;
